module.exports = __webpack_public_path__ + "static/gm-15-09a720ae7810e2fe64ec341467b5eedd.jpg";